import options from './on-enter.directive';

export default {
    selector: 'onEnter',
    options
};
